import { FEE_TAX_SETTING } from "@dw/models/shared";

export enum COUNTRY_CODE {
  NZ = "NZ"
}
export const DEFAULT_COUNTRY_CODE = COUNTRY_CODE.NZ;

export const LOCALISED_TAX_NAME: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: 'GST'
}
export const LOCALISED_TAX_SETTING_OPTIONS: Record<COUNTRY_CODE, Record<FEE_TAX_SETTING, { title: string; description: string; }>> = {
  [COUNTRY_CODE.NZ]: {
    [FEE_TAX_SETTING.NO_TAX]: {
      title: `No ${LOCALISED_TAX_NAME[COUNTRY_CODE.NZ]}`,
      description: 'Nothing will be added to specified amount'
    },
    [FEE_TAX_SETTING.TAX_INCLUDED]: {
      title: `${LOCALISED_TAX_NAME[COUNTRY_CODE.NZ]} Included`,
      description: `Specified amount already includes 15% ${LOCALISED_TAX_NAME[COUNTRY_CODE.NZ]}`
    },
    [FEE_TAX_SETTING.TAX_EXCLUDED]: {
      title: `${LOCALISED_TAX_NAME[COUNTRY_CODE.NZ]} Excluded`,
      description: `15% ${LOCALISED_TAX_NAME[COUNTRY_CODE.NZ]} will be added to specified amount`
    }
  }
}

export const TAX_PERCENTAGES: Record<COUNTRY_CODE, number> = {
  [COUNTRY_CODE.NZ]: 0.15
}

export const COUNTRY_NAMES: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: 'New Zealand'
}

export const PHONE_NUMBER_COUNTRY_CODES: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: '+64'
}

export const COUNTRY_CODE_LOCALES: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: 'en-NZ'
}

export const COUNTRY_CODE_CURRENCIES: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: 'NZD'
}

export const COUNTRY_CODE_CURRENCY_SYMBOLS: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: '$'
}

/**
 * Maps the API `CountryCode` enum name (serialized as its PascalCase name, e.g. "NewZealand")
 * to the WebPortal `COUNTRY_CODE`. Also accepts the short code ("NZ") for resilience.
 */
export const API_COUNTRY_NAME_TO_COUNTRY_CODE: Partial<Record<string, COUNTRY_CODE>> = {
  NewZealand: COUNTRY_CODE.NZ,
  NZ: COUNTRY_CODE.NZ
}

/**
 * Resolves an API country value (name or code) to a WebPortal `COUNTRY_CODE`,
 * falling back to the default country when the value is missing or unrecognised.
 */
export const resolveCountryCode = (apiCountryCode?: string | null): COUNTRY_CODE =>
  (apiCountryCode ? API_COUNTRY_NAME_TO_COUNTRY_CODE[apiCountryCode] : undefined) ?? DEFAULT_COUNTRY_CODE;